import { Component, OnInit, Inject } from '@angular/core';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Utility } from '../../../common/utility';

import { DialogService } from '../../../shared/services/dialog.service';
import { BaseService } from '../../../shared/services/base.service';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';

import { DialogComponent } from '../../../components/dialog/dialog.component';
import { ViewScheduleService } from './view-schedule-popup.service';
import { PatientVaccineVisit } from '../../../models/consultation/patient.model';

@Component({
  selector: 'view-schedule-popup',
  templateUrl: 'view-schedule-popup.component.html',
  providers: [ViewScheduleService]
})
export class ViewSchedulePopupComponent implements OnInit {
  public appMessages = AppMessages;
  public dataDateVaccine = [];
  public dataVaccine = [];
  public dataTestOrdered = [];
  public dataPrice = [];
  public dateVaccine = [];
  public scheduleIds = [];
  public patientLabtestId = [];
  public appConstants = AppConstants;
  public patientVaccineVisit = PatientVaccineVisit;
  public administerVaccine = false;
  public rate;
  public visitCurrentDay = false;
  constructor(
    public utility: Utility,
    public baseService: BaseService,
    public dialogService: DialogService,
    public viewScheduleService: ViewScheduleService,
    @Inject(MD_DIALOG_DATA) public data: any,
    public dialogRef: MdDialogRef<ViewSchedulePopupComponent>
  ) { }

  ngOnInit() {
    this.viewScheduleService.getVaccine(this.data.consultationId).subscribe(
      (result) => {
        if (result) {
          this.dataVaccine = [];
          const resultData = result.json();
          resultData.forEach(element => {
            this.dataVaccine.push(element.vaccine);
          });
          this.isCheckData();
          this.dataDateVaccine.forEach(d => {
            this.dateVaccine.push(d.visitDate);
          });
          this.initPrice();
        }
      }
    );
    this.viewScheduleService.getTestOrdered(this.data.consultationId).subscribe(
      (result) => {
        if (result) {
          this.dataTestOrdered = result.json();
        }
      }
    );

  }

  onCloseDialog() {
    this.dialogRef.close();
  }

  isCheckData() {
    if (this.dataVaccine.length < 1) {
      this.administerVaccine = true;
    } else {
      this.dataDateVaccine = this.dataVaccine[0].vaccineDates;
      this.dataDateVaccine.forEach(i => {
        if (i.visit === PatientVaccineVisit.Past || i.visit === PatientVaccineVisit.Current) {
          this.visitCurrentDay = true;
        }
      }
      );
      const dataCurrency = this.dataDateVaccine[0].currencyRate;
      dataCurrency.forEach(i => {
        if (this.data.currency.code === i.code) {
          this.rate = i.rate;
        }
      });
    }
  }

  initPrice() {
    for (let i = 0; i < this.dateVaccine.length; i++) {
      if (this.dateVaccine[i]) {
        let totalPrice = 0;
        this.dataVaccine.forEach(e => {
          e.vaccineDates.forEach(k => {
            if ((k.isChecked && k.isPaid) && (k.visitDate === this.dateVaccine[i])) {
              totalPrice += (k.price) * this.rate;
            }
          });
        });
        this.dataPrice[i] = totalPrice;
      }
    }
  }


  onCheckedInvoice(item, checkbox, event) {
    if (event.checked) {
      const list = { 'id': checkbox.id, 'day': checkbox.visitDate, 'item': item.vaccineName };
      for (let i = 0; i < this.dateVaccine.length; i++) {
        if ((checkbox.visitDate === this.dateVaccine[i]) && !(checkbox.isPaid)) {
          const index = this.dateVaccine.indexOf(this.dateVaccine[i]);
          this.dataPrice[index] += (checkbox.price) * this.rate;
          this.scheduleIds.push(list.id);
        }
      }
    } else {
      for (let i = 0; i < this.dateVaccine.length; i++) {
        if (checkbox.visitDate === this.dateVaccine[i]) {
          const index = this.dateVaccine.indexOf(this.dateVaccine[i]);
          this.dataPrice[index] -= (checkbox.price) * this.rate;
          this.scheduleIds.forEach(n => {
            if (n === checkbox.id) {
              const indexList = this.scheduleIds.indexOf(n);
              this.scheduleIds.splice(indexList, 1);
            }
          });
        }
      }
    }
  }

  onCheckedLabtest(item, event) {
    const index = this.patientLabtestId.findIndex(x => x === item.id);
    if (event.checked) {
      if (index < 0) {
        this.patientLabtestId.push(item.id);
      }
    } else if (index >= 0) {
      this.patientLabtestId.splice(index, 1);
    /*   this.patientLabtestId.forEach(n => {
        if (n.item === item.labTestName) {
          const indexList = this.patientLabtestId.indexOf(n);
          this.patientLabtestId.splice(indexList, 1);
        }
      }); */
    }
  }

  onSubmit() {
    if (this.scheduleIds.length > 0 || this.patientLabtestId.length > 0) {
      const data = {
        ScheduleIds: this.scheduleIds,
        PatientLabtestIds: this.patientLabtestId
      };
      // call API
      this.viewScheduleService.updateInvoiceItem(this.data.consultationId, this.data.invoiceId, data).subscribe(
        result => {
          if (result) {
            this.dialogRef.close(result.json());
          }
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/view-schedule-popup.component.ts